import type { useTranslations } from 'next-intl'

/** `useTranslations('browse')`. */
type BrowseTranslator = ReturnType<typeof useTranslations<'browse'>>

export type FlowRemixPromptMeta = {
  brandName: string
  emailCount: number
}

/** The signed-out remix box's placeholder: what it remixes, in one line. */
export function buildFlowRemixPlaceholder(
  t: BrowseTranslator,
  meta: FlowRemixPromptMeta
): string {
  return t('flows.remixPlaceholder', {
    count: meta.emailCount,
    brandName: meta.brandName,
  })
}
